
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header mfp-header">
                <div class="d-flex justify-content-between">
                    <h4 class="d-inline-block align-self-center mb-0">Messages</h4>
                    <div class="d-inline-block">
                        <select class="form-select" [(ngModel)]="Prefilter">
                            <option *ngFor="let prefilter of Prefilters" [value]="prefilter.Value">{{ prefilter.Text }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="list-group">
                <div class="list-group-item">
                    <data-table-filter [config]="TableConfig" [prefilter]="Prefilter" [initialFilters]="InitialFilters" (filterChange)="Filter = $event"></data-table-filter>
                </div>
                <div class="list-group-item">
                    <div class="row">
                        <div class="col-12 col-md-5 col-lg-7 col-xl-8 my-1 text-center text-md-start">
                            <button type="button" class="btn btn-secondary mx-1" (click)="CreateMessage()">New</button>
                            <button type="button" class="btn btn-secondary mx-1" (click)="EditMessage()">Edit</button>
                            <button type="button" class="btn btn-secondary mx-1" (click)="ConvertMessageToTask()">Convert to Task</button>
                        </div>
                        <div class="col-12 col-md-7 col-lg-5 col-xl-4 my-1">
                            <data-table-pager [(PageIndex)]="PageIndex" [PageCount]="PageCount"></data-table-pager>
                        </div>
                    </div>
                </div>
                <div class="list-group-item">
                    <div class="overflow-auto">
                        <data-table
                            [config]="TableConfig"
                            [Filter]="Filter"
                            [(PageIndex)]="PageIndex"
                            (PageCountChange)="PageCount = $event"
                            [PageSize]="10"
                            [Ready]="Ready"
                        ></data-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>